/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { REPORT_RENAME_FORM_START } from 'state/action-types';

import { createReducer } from 'state/utils';

const reportId = createReducer(null, {
	[REPORT_RENAME_FORM_START]: (state, action) => {
		return action.payload.reportId || null;
	},
});

export default combineReducers({
	reportId,
});
